import { getOperation, fetchFinance, fetchOperation } from "utils/api";

export const queryPayment = async (params) => {
  return await getOperation("/payment/list", {
    page: 0,
    size: 20,
    sort: "created,desc",
    ...params,
  });
};

export const queryTransaction = async (params) => {
  return await getOperation("/transaction/list", {
    page: 0,
    size: 20,
    sort: "time,desc",
    ...params,
  });
};

export const sendReceiptForm = async (params) => {
  return await fetchOperation("/transaction/action", {
    receiptType: "EMAIL",
    transactionType: "RECEIPT",
    ...params,
  });
};

export const voidTransactionForm = async (params) => {
  return await fetchOperation("/transaction/action", {
    ...params,
  });
};

export const getTransactionRefundable = async (params) => {
  return await fetchFinance("/action", {
    method: "post",
    action: "getRefundable",
    ...params,
  });
};

export const refundTransaction = async (params) => {
  return await fetchOperation("/transaction/action", {
    transactionType: "SALE_REFUND",
    ...params,
  });
};
